import MessageInputBar from "./MessageInputBar";
import ConversationHeader from "./ConversationHeader";
import MessagesList from "./MessagesList";

export default function MobileConversation({
  counterpartyId,
}: {
  counterpartyId: string;
}) {
  return (
    <div className="flex flex-col fixed inset-0 bg-black pt-safe-top">
      <ConversationHeader counterpartyId={counterpartyId} />
      <MessagesList counterpartyId={counterpartyId} />
      <MessageInputBar counterpartyId={counterpartyId} />
    </div>
  );
}
